import moment from 'moment-timezone';

const US_TIMEZONE_DATA = [
  { name: 'US/PACIFIC', momentName: 'US/Pacific', zone: 'PACIFIC' },
  { name: 'US/MOUNTAIN', momentName: 'US/Mountain', zone: 'MOUNTAIN' },
  { name: 'US/CENTRAL', momentName: 'US/Central', zone: 'CENTRAL' },
  { name: 'US/EASTERN', momentName: 'US/Eastern', zone: 'EASTERN' },
  { name: 'US/ALASKA', momentName: 'US/Alaska', zone: 'ALASKA' },
  { name: 'US/HAWAII', momentName: 'US/Hawaii', zone: 'HAWAII' }
];

const formatOffsetTitle = offset => `GMT${offset}`;
const formatTitle = zoneName => zoneName.charAt(0) + zoneName.slice(1).toLowerCase();

const getTimezoneMoment = ({ interviewDate, time, timezoneName }) => {
  const dateMoment = interviewDate ? moment(interviewDate) : null;
  const matchedTime = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(time);

  if (!dateMoment?.isValid()) return moment().tz(timezoneName);

  const [, hour = '12', minute = '00'] = matchedTime || [];

  return moment.tz(
    {
      year: dateMoment.year(),
      month: dateMoment.month(),
      date: dateMoment.date(),
      hour: Number(hour),
      minute: Number(minute)
    },
    timezoneName
  );
};

export const getTimezones = ({ interviewDate = null, time = null } = {}) => {
  return US_TIMEZONE_DATA.map(data => {
    const timezoneMoment = getTimezoneMoment({
      interviewDate,
      time,
      timezoneName: data.momentName
    });

    return {
      name: data.name,
      momentName: data.momentName,
      title: `${formatTitle(data.zone)} Time`,
      offset_title: formatOffsetTitle(timezoneMoment.format('Z')),
      offset: timezoneMoment.utcOffset() / 60,
      initials: timezoneMoment.format('z')
    };
  });
};
